// extracted by mini-css-extract-plugin
export default {"PageEmptyState":"PageEmptyState_PageEmptyState__ZQ+vQ"};